"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const ContactAddressForm_1 = __importDefault(require("./ContactAddressForm"));
const GaDataStore_1 = __importDefault(require("../../stores/GaDataStore"));
const StoresUtil_1 = require("../../util/StoresUtil");
let ContactInfoForm = class ContactInfoForm extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "contactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inputFieldFilled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "inputFieldFocused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "saveContactInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                await this.contactInfoStore.saveCustomerInfo();
                this.contactAddressStore.address = null;
            }
        });
        Object.defineProperty(this, "renderError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { translate } = this.translateStore;
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "small" }),
                    react_1.default.createElement(lib_1.Notice, { size: "small", type: "attention" }, translate('global.server.error'))));
            }
        });
        Object.defineProperty(this, "setEmailInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.onInputFieldFilled('contact-info-email');
                this.contactInfoStore.changeEmailInfo(value);
            }
        });
        Object.defineProperty(this, "setPhoneInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.onInputFieldFilled('contact-info-phone');
                this.contactInfoStore.changePhoneInfo(value);
            }
        });
        Object.defineProperty(this, "onInputFieldFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field) => {
                if (!this.inputFieldFocused.has(field)) {
                    this.inputFieldFocused.set(field, true);
                }
            }
        });
        Object.defineProperty(this, "onInputFieldFilled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field) => {
                if (!this.inputFieldFilled.has(field)) {
                    this.inputFieldFilled.set(field, true);
                }
            }
        });
    }
    render() {
        return react_1.default.createElement(lib_1.Container, null, this.contactInfoStore.isCustomerConsentReady ? null : this.renderContactInfo());
    }
    renderContactInfo() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(lib_1.Modal, { size: "6-col", isOpen: !this.contactInfoStore.isCustomerConsentReady, hasContentComponent: true, onClose: () => {
                this.contactInfoStore.isCustomerConsentReady = true;
                GaDataStore_1.default.pushAnalyticsObject('GDPR contact info form', 'Button - gdpr-contact-info-modal-cancel');
            } },
            react_1.default.createElement(lib_1.ModalContent, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement(lib_1.Heading, { element: "h2", className: "h3" }, translate('contactInfo.title')),
                    react_1.default.createElement("p", null, translate('contactInfo.info')),
                    react_1.default.createElement("form", { autoComplete: "off" },
                        react_1.default.createElement(lib_1.Grid, null,
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12'] },
                                react_1.default.createElement(lib_1.TextField, { isInvalid: !this.contactInfoStore.isEmailValidOrEmpty, helper: this.getEmailHelper(), label: translate('contactInfo.email'), value: this.contactInfoStore.emailInfo.value, onChange: this.setEmailInfo, onFocus: () => this.onInputFieldFocus('contact-info-email'), id: "contact-info-email", type: "email" })),
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12'] },
                                react_1.default.createElement(lib_1.TextField, { isInvalid: !this.contactInfoStore.isPhoneValidOrEmpty, label: translate('contactInfo.phone'), helper: this.getPhoneHelper(), id: "contact-info-phone", value: this.contactInfoStore.phoneInfo.value, type: "tel", onChange: this.setPhoneInfo, onFocus: () => this.onInputFieldFocus('contact-info-phone') })),
                            react_1.default.createElement(ContactAddressForm_1.default, { addressRepresentation: this.contactAddressStore.address })))),
                this.contactInfoStore.formIsErrorneous ? this.renderError() : null),
            react_1.default.createElement(lib_1.ModalFooter, { className: 'text-right' },
                react_1.default.createElement(GaButton_1.default, { id: "contact-info-save", disabled: !this.contactInfoStore.isFormValid, onClick: this.saveContactInfo, text: translate('gdpr.sign.confirm') }))));
    }
    getEmailHelper() {
        const { translate } = this.translateStore;
        if (!this.contactInfoStore.isEmailValidOrEmpty) {
            return {
                type: 'error',
                text: translate('contactInfo.emailInvalid')
            };
        }
        return null;
    }
    getPhoneHelper() {
        const { translate } = this.translateStore;
        if (!this.contactInfoStore.isPhoneValidOrEmpty) {
            return {
                type: 'error',
                text: translate('contactInfo.phoneInvalid')
            };
        }
        return null;
    }
};
ContactInfoForm = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContactInfoForm);
exports.default = ContactInfoForm;
